import { Component, Output, EventEmitter } from "@angular/core"
import { ModalComponent } from "../modal.component"

@Component({
  selector: 'new-video-subscription-learn-more-modal',
  template: `
    <modal [width]="width" (outsideClick)="close.emit()">
      <h4>Video + Written Content = The SEO Edge</h4>
      <hr class="brand-hr">
      <p class="h4-subheader">
        Add more channels to your inbound arsenal.
        Amplify on social media or embed in your HubSpot content.
        Verblio Vids are the multimedia key to diversify the ways your audience can consume written content you've published, and increase your SEO.
        Amplify on social media or embed in your content.
      </p>

      <h5 class="mt-4">Sample summary Verblio Vid</h5>
      <embed-video></embed-video>

      <div>
        <button class="btn btn-outline-secondary mt-3" (click)="close.emit()">Close</button>
        <div *ngIf="false" class="float-right mt-3 p-2">
          <a href="https://help.verblio.com">Learn more</a>
        </div>
      </div>
    </modal>
  `
})
export class NewVideoSubscriptionLearnMoreModal extends ModalComponent {
  @Output() close: EventEmitter<null> = new EventEmitter<null>()
}
